import React, { Component } from 'react';
import pdf from './../../utils/Forms/VisionReimbursementForm.pdf';

class FloatContent extends Component {
    componentDidMount() {
        require("./css/FloatContent.css");
    }
    render() {
        return (


            <div className="Float_Container">
                <div className="Float_Content">
                    <h3>Need the correct form?</h3>
                    <a href={pdf} target="_blank" rel="noopener noreferrer" >Vision Reimbursement Form</a>
                </div>
                <div className="Float_Content">
                    <h3>Need some help?</h3>
                    <p>We're here for you!<br></br> Give one of our agents a call and we'll help you through the process. <br></br><a href="tel:435-563-0613">435-563-0613</a></p>
                </div>
                <div className="Float_Content">
                    <h3>Go anywhere, we'll reimburse you!</h3>
                </div>

            </div>

        );
    }
};
export default FloatContent;